import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import {STATION_HEADER_COLORS} from "../GameStyleUI";
import brigade_chips_icon from "../../../images/gameplay_ui/icons/brigade_chips_icon.svg";
import GameController from "../../../gameplay/controllers/GameController";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import GameTabViewUI from "../Tabs/GameTabViewUI";
import car_train_icon from "../../../images/gameplay_ui/icons/car_train_icon.svg";

import GameData from "../../../gameplay/model/GameData";
import LocoPopupCard from "../LocoCards/LocoPopupCard";
import GameButtonWithText from "../GameButtonWithText";
import TrainCarPackCard from "../LocoCards/TrainCarPackCard";
import {
    LOCO_CARGO_LIFTING_CAPACITY,
    LOCO_EMPTY_LIFTING_CAPACITY,
    MAX_TRAIN_LIFTING_CAPACITY,
} from "../../../gameplay/model/Balance";
import {ELECTRO_TYPE, LOCO_TYPE} from "../../../constants/Constants";
import agent from "../../../agent";
import UtilsFunctions from "../../../utils/UtilsFunctions";

export default class TrainCreateWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            currentLocos: [],
            currentTrainCars: []
        }
    }

    componentDidMount() {
    }

    selectPage(pageNum) {
        this.setState({
            currentPage: pageNum,
            currentLocos: [],
            currentTrainCars: []
        });
    }

    onCreateTrain() {
        let HRIndex = UtilsFunctions.getRoleNameIndex("Зам. по кадрам и социальным вопросам")

        if (!UtilsFunctions.playerHasRole(HRIndex)) {
            alert("Формировать составы на станции может только Зам. по кадрам и социальным вопросам");
            return;
        }

        let isAtLeastOneHot = false;
        let locos = this.state.currentLocos;
        for (let i = 0; i < locos.length; i++) {
            let loco = locos[i];
            if (loco.isHot) {
                isAtLeastOneHot = true;
                break;
            }
        }
        if (!isAtLeastOneHot) {
            alert("В одном составе должен быть хотя бы один ведущий локомотив")
            return;
        }
        if (this.getCurrentTrainCarPacks() > this.getCurrentTrainLiftingCapacity()) {
            alert("Грузоподъёмности локомотивов недостаточно для формирования состава")
            return;
        }
        let isLocoHot = false;
        let isElectroHot = false;
        for (let i = 0; i < locos.length; i++) {
            let loco = locos[i];
            if (loco.isHot) {

                switch (loco.partsType) {
                    case "loco":
                        isLocoHot = true;
                        break;
                    case "electro":
                        isElectroHot = true;
                        break;
                    default:
                        break;
                }
            }
        }
        if (isElectroHot && isLocoHot) {
            alert("В одном составе не может быть горячих локомотивов разных типов")
            return;
        }
        let forSendLocos = [];
        for (let i = 0; i < locos.length; i++) {
            forSendLocos.push({id: locos[i].id, isHot: locos[i].isHot})
        }
        agent.GamePlay.createTrain(this.props.teamID, {
                stationId: this.props.station.id,
                locos: forSendLocos,
                trainCarPacks: this.state.currentTrainCars,
                trainType: this.state.currentPage,
                locoType: isElectroHot ? ELECTRO_TYPE : LOCO_TYPE
            },
            (response) => console.log(response))
        GameData.CurrentGame.createTrain(
            this.props.station,
            this.state.currentLocos,
            this.state.currentTrainCars,
            this.state.currentPage,
            isElectroHot ? ELECTRO_TYPE : LOCO_TYPE);
        this.props.onHide();
    }

    getShort() {
        const locoSlots = 3;
        let locoGridStyle = {
            paddingTop: "20px",
            display: "grid",
            gridTemplateColumns: "110px 110px 110px 153px 153px",
            gridColumnGap: "10px"
        }
        let locoSlotStyle = {
            height: "160px",
            background: "rgba(3, 3, 3, 0.1)",
            borderRadius: "5px",
        }
        let trainSlots = [];
        for (let i = 0; i < 5; i++) {
            if (i < locoSlots) {
                trainSlots.push(<div style={locoSlotStyle} key={i}>
                    {this.state.currentLocos.length > i ?
                        <LocoPopupCard parent={this} canSetHot={true} loco={this.state.currentLocos[i]}
                                       style={{padding: "5px"}} onClick={val => {
                            let state = this.state;
                            val.isHot = false;
                            state.currentLocos = state.currentLocos.filter(x => x !== val);
                            this.setState(state);
                        }}/> : ""}
                </div>);
            } else {
                trainSlots.push(<div style={locoSlotStyle} key={i}>
                    {this.state.currentTrainCars.length > (i - locoSlots) ? <TrainCarPackCard
                            trainCarsPack={this.state.currentTrainCars[i - locoSlots]} style={{padding: "5px"}}
                            onClick={val => {
                                let state = this.state;
                                state.currentTrainCars = state.currentTrainCars.filter(x => x !== val);
                                this.setState(state);
                            }}/>
                        : ""}
                </div>);
            }

        }
        return <div style={locoGridStyle} key={'train-short'}>
            {trainSlots}
        </div>
    }

    getLong() {
        const locoSlots = 5;
        let locoGridStyle = {
            paddingTop: "20px",
            display: "grid",
            gridTemplateColumns: "110px 110px 110px 110px 110px 153px 153px 153px 153px 153px",
            gridColumnGap: "10px"
        }
        let locoSlotStyle = {
            height: "159px",
            background: "rgba(3, 3, 3, 0.1)",
            borderRadius: "5px"
        }
        let trainSlots = [];
        for (let i = 0; i < 10; i++) {
            if (i < locoSlots) {
                trainSlots.push(<div style={locoSlotStyle} key={`i-${i}`}>
                    {this.state.currentLocos.length > i ?
                        <LocoPopupCard parent={this} canSetHot={true} loco={this.state.currentLocos[i]}
                                       style={{padding: "5px"}} onClick={val => {
                            let state = this.state;
                            val.isHot = false;
                            state.currentLocos = state.currentLocos.filter(x => x !== val);
                            this.setState(state);
                        }}/> : ""}
                </div>);
            } else {
                trainSlots.push(<div style={locoSlotStyle} key={`i-${i}`}>
                    {this.state.currentTrainCars.length > (i - locoSlots) ? <TrainCarPackCard
                            trainCarsPack={this.state.currentTrainCars[i - locoSlots]} style={{padding: "5px"}}
                            onClick={val => {
                                let state = this.state;
                                state.currentTrainCars = state.currentTrainCars.filter(x => x !== val);
                                this.setState(state);
                            }}/>
                        : ""}
                </div>);
            }
        }
        return <div style={locoGridStyle} key={'train-long'}>
            {trainSlots}
        </div>
    }

    getLocoScroll() {
        let currentLocoLimit = this.state.currentPage === 0 ? 3 : 5;
        let scrollStyle = {
            display: "flex",
            width: "1415px",
            height: "169px",
            overflowX: "visible",
            overflowY: "hidden"
        }
        let station = this.props.station;
        let locos = GameData.CurrentGame.getStationLocomotives(station.id);
        let locoCards = [];
        for (let i = 0; i < locos.length; i++) {

            if (this.isLocoAvailableInScroll(locos[i])
                && !GameData.CurrentGame.isLocoInAnyTrain(locos[i])
            ) {
                locoCards.push(<LocoPopupCard key={`k-${i}`} loco={locos[i]} style={{paddingRight: "10px"}} onClick={val => {

                    if (this.state.currentLocos.length < currentLocoLimit) {
                        let state = this.state;
                        val.isHot = false;
                        state.currentLocos.push(val);
                        this.setState(state);
                    }

                }}/>);
            }


        }
        return <div style={scrollStyle} key={'loco-scroll'}>
            {locoCards}
        </div>
    }

    isLocoAvailableInScroll(loco) {
        for (let i = 0; i < this.state.currentLocos.length; i++) {
            if (loco.id === this.state.currentLocos[i].id) return false;
        }
        return true;
    }

    getTrainCarScroll() {
        let currentTrainLimit = this.state.currentPage === 0 ? 2 : 5;
        let scrollStyle = {
            paddingTop: "20px",
            display: "flex",
            width: "1415px",
            height: "169px",
            overflowX: "visible",
            overflowY: "hidden"
        }
        let station = this.props.station;
        let trainPacks = station.trainCarsPacks;
        let trainPacksCards = [];
        for (let i = 0; i < trainPacks.length; i++) {
            if (!this.state.currentTrainCars.includes(trainPacks[i]))
                trainPacksCards.push(<TrainCarPackCard key={`pack-${i}`} trainCarsPack={trainPacks[i]} onClick={val => {
                    if (this.state.currentTrainCars.length < currentTrainLimit) {
                        let state = this.state;
                        state.currentTrainCars.push(val);
                        this.setState(state);
                    }
                }}/>);
        }
        return <div key={'train-car-scroll'} style={scrollStyle}>
            {trainPacksCards}
        </div>
    }

    getCurrentTrainCarPacks() {
        return GameController.calculateCargoWeight(this.state.currentTrainCars)
    }

    getCurrentTrainWeight() {
        return 0;
    }

    getCurrentTrainLiftingCapacity() {
        let locos = this.state.currentLocos.filter(x => x.isHot);
        if (locos.length === 0) return 0;
        let type = locos[0].partsType;

        let emptyCarPacks = this.state.currentTrainCars.filter(el => GameData.CurrentGame.getTrainCarById(el).type === "empty");
        let allCarPacksAreEmpty = emptyCarPacks.length === this.state.currentTrainCars.length;

        let liftingCapacityMultiplier = allCarPacksAreEmpty ? LOCO_EMPTY_LIFTING_CAPACITY[type] : LOCO_CARGO_LIFTING_CAPACITY[type];
        return Math.min(MAX_TRAIN_LIFTING_CAPACITY[this.state.currentPage], locos.length * liftingCapacityMultiplier);
    }

    render() {
        let width = 1435;
        let station = this.props.station;
        let mainStyle = {
            paddingTop: "40px",
            paddingLeft: "10px"
        }
        let moveStyle = {
            position: "absolute",
            left: this.props.width / 2,
            top: this.props.height / 2,
            transform: window.innerWidth > 1500 ? "translate(-50%,-50%)" : "translate(-50%, -54%) scale(0.78)"
        }

        let colors = STATION_HEADER_COLORS[station.id];
        let content = [];
        content.push(<GameTabViewUI
          key={'tab-ui'}
          width={width - 20}
          height={30}
          tabs={["Обычный поезд", "Длинносоставный поезд"]}
          onSelectedIndex={this.selectPage.bind(this)}
        />);
        content.push(this.state.currentPage === 0 ? this.getShort() : this.getLong());
        content.push(<div key={'button-container'} style={{
            paddingTop: "20px",
            paddingBottom: "40px",
            width: `${width - 20}px`,
            textAlign: "center"
        }}>
            <GameButtonWithText
              title={"Составить поезд"}
              width={250}
              height={40}
              onClick={this.onCreateTrain.bind(this)}
            />
        </div>);
        content.push(<div key={'bg'} style={{
            width: `${width - 20}px`,
            height: "1px",
            marginBottom: "15px",
            background: "rgba(3, 3, 3, 0.3)"
        }}/>);

        content.push(this.getLocoScroll());
        content.push(this.getTrainCarScroll());

        let currencyBlocks = [];
        currencyBlocks.push(<CurrencyCard
            key={'currency-card-1'}
            title={"Трудозатраты"}
            icon={brigade_chips_icon}
            value={GameController.calculateAvailableStationBrigadesChips(station)}
            size={20}
            fontSize={14}
            style={{
                marginLeft: "10px"
            }}
        />);
        currencyBlocks.push(<CurrencyCard
            key={'currency-card-2'}
            title={"Груз/Грузоподъемность"}
            icon={car_train_icon}
            value={`${this.getCurrentTrainCarPacks()}/${this.getCurrentTrainLiftingCapacity()}`}
            size={20}
            fontSize={14}
            style={{
                marginLeft: "10px"
            }}
        />);
        // currencyBlocks.push(<CurrencyCard
        //     icon={loco_icon}
        //     value={`${this.getCurrentTrainWeight()}/${this.getCurrentTrainLiftingCapacity()}`}
        //     size={20}
        //     fontSize={14}
        //     style={{
        //         marginLeft: "10px"
        //     }}
        // />);
        content = <div style={mainStyle}>{content}</div>
        return <div className="in-game-popup" style={{
            width: this.props.width,
            height: this.props.height,
            background: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)"
        }}>
            <div style={moveStyle}>
                <GameWindowHeader
                  width={width} height={40} colorStart={colors[0]} colorEnd={colors[1]}
                  onHide={this.props.onHide} title={`${station.name}: формирование состава`}
                  isClosable={true} currencyBlocks={currencyBlocks}
                />
                <GameWindowBg color={"#F2F2F2"} width={width} height={760} value={content}/>
            </div>

        </div>;
        ;
    }
}
